import { FlowerDoodle } from "./Doodles";
import { useLang } from "../lang/LanguageContext";

const ITEMS = [
    "Play. Learn. Grow. Flourish.",
    "Play-based learning",
    "Meals included",
    "OCFS license active",
    "Open 6:00 AM – 8:00 PM",
    "Seedlings · Sprouts · Blooms",
    "Open door policy",
    "Massapequa Park, NY",
];

const Row = ({ hidden = false }) => {
    const { t } = useLang();
    return (
        <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="font-display font-semibold text-lg md:text-xl text-soil px-6 whitespace-nowrap">{t(item)}</span>
                    <FlowerDoodle size={22} petals="#FFF8EC" className="opacity-90" />
                </span>
            ))}
        </div>
    );
};

export default function Marquee() {
    return (
        <div className="relative bg-sage py-4 overflow-hidden" data-testid="home-marquee-band">
            <div className="flex w-max animate-marquee motion-reduce:animate-none">
                <Row />
                <Row hidden />
            </div>
        </div>
    );
}
